module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="form-controls add-user-lightbox">\n    <h2 class="header">Add User</h2>\n    <div class="row">\n        <div class="col-xs-6">\n            <input type="text" class="name" placeholder="Enter name">\n            <input type="text" class="email" placeholder="Enter email">\n        </div>\n        <div class="col-xs-6">\n            <select class="roles form-control">\n                <option value="">Choose role</option>\n                <option value="Spectator">Spectator</option>\n                <option value="Creator">Creator</option>\n                <option value="Publisher">Publisher</option>\n                <option value="Manager">Manager</option>\n            </select>\n        </div>\n    </div>\n\n    <div class="actions">\n        <button class="btn btn-not-valid pull-right ladda-button ok" data-spinner-size="28" data-style="expand-right">OK</button>\n        <button class="btn btn-secondary pull-right cancel">Cancel</button>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/manageAccount/AddUserView.tpl
// module id = 3110
// module chunks = 0